module.exports = __webpack_public_path__ + "img/header.604c9204.jpg";